import { render, staticRenderFns } from "./SegmentVectorLayer.vue?vue&type=template&id=b5ce398e&scoped=true&"
import script from "./SegmentVectorLayer.vue?vue&type=script&lang=js&"
export * from "./SegmentVectorLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ce398e",
  null
  
)

export default component.exports